import {stateRegions} from "../models/stateRegions";

export class validationAdress {
    constructor(state) {
        this.state = this.capital_letter(state)
    }

    validationAdressFunc() {
        let obj = null
        stateRegions.every(el => {
            if (el.states.includes(this.state)) {
                obj = el
                return false
            }
            return true
        })
        return obj ? obj :stateRegions.find(r => r.isDefault === true)
    }

    capital_letter(str) {
        if (str == null) return null
        str = str.split(" ");
        for (var i = 0, x = str.length; i < x; i++) {
            str[i] = str[i][0].toUpperCase() + str[i].substr(1);
        }
        return str.join(" ");
    }
}